import { GOOGLE_PLACES_API_KEY } from "@shared/env";
import axios from "axios";

type GetGeocodeParamsType = {
  address: string;
};

export const getGeocode = async (
  params: GetGeocodeParamsType
): Promise<{ results: google.maps.GeocoderResult[] }> => {
  const { data } = await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json`,
    {
      params: { ...params, key: GOOGLE_PLACES_API_KEY },
      withCredentials: false,
    }
  );

  return data;
};
